import type { BottomSheetConnectorProps } from './BottomSheetConnector.types';

const gradientVariants = {
  primary: 'from-primary-300 via-primary-400/80 to-transparent',
  accent: 'from-accent-300 via-accent-400/80 to-transparent',
} as const;

/**
 * Mobile-only beam animation that connects a trigger element to a bottom sheet.
 * Creates a visual "beam" effect when the dropdown opens on mobile devices.
 *
 * @example
 * ```tsx
 * // User dropdown (avatar position)
 * <BottomSheetConnector isAnimating={isAnimating} rightOffset={24} />
 *
 * // Notification dropdown (bell icon position)
 * <BottomSheetConnector isAnimating={isAnimating} rightOffset={68} />
 * ```
 */
export function BottomSheetConnector({
  isAnimating,
  rightOffset,
  variant = 'primary',
}: BottomSheetConnectorProps) {
  return (
    <div
      className={`
        hidden max-[479px]:block
        fixed top-[calc(theme(spacing.14)/2)]
        w-0.5 h-0
        bg-gradient-to-b ${gradientVariants[variant]}
        rounded-sm z-[100] pointer-events-none origin-top
        ${isAnimating ? 'animate-connector-beam' : ''}
      `}
      style={{ right: rightOffset }}
      aria-hidden="true"
    />
  );
}

export default BottomSheetConnector;
